import { render, staticRenderFns } from "./SocialServicesDialog.vue?vue&type=template&id=7c816e44&"
import script from "./SocialServicesDialog.vue?vue&type=script&lang=js&"
export * from "./SocialServicesDialog.vue?vue&type=script&lang=js&"
import style0 from "./SocialServicesDialog.vue?vue&type=style&index=0&id=7c816e44&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports